import { z } from 'zod';

const passwordSchema = z
  .string()
  .min(8, 'A senha deve ter no mínimo 8 caracteres!')
  .regex(/[A-Z]/, 'Deve conter pelo menos uma letra maiúscula!')
  .regex(/[a-z]/, 'Deve conter pelo menos uma letra minúscula!')
  .regex(/[0-9]/, 'Deve conter pelo menos um número!')
  .regex(/[^A-Za-z0-9]/, 'Deve conter pelo menos um caractere especial!');

const optionalPassword = z
  .union([passwordSchema, z.literal('')])
  .optional()
  .transform((val) => (val === '' ? undefined : val));

export const signInSchema = z.object({
  email: z.email('E-mail inválido!'),
  password: z.string().min(1, 'Informe a senha!'),
  remember: z.boolean().optional(),
});

export const updateProfileSchema = z
  .object({
    avatar: z.string().optional(),
    name: z.string().min(3, 'O nome deve ter no mínimo 3 caracteres!').optional(),
    email: z.email('E-mail inválido!').optional(),
    currentPassword: optionalPassword,
    newPassword: optionalPassword,
    confirmPassword: optionalPassword,
  })
  .superRefine((data, ctx) => {
    if (data.currentPassword) {
      if (!data.newPassword) {
        ctx.addIssue({
          code: 'custom',
          message: 'Informe a nova senha!',
          path: ['newPassword'],
        });
      }

      if (!data.confirmPassword) {
        ctx.addIssue({
          code: 'custom',
          message: 'Confirme a nova senha!',
          path: ['confirmPassword'],
        });
      }

      if (
        data.newPassword &&
        data.confirmPassword &&
        data.newPassword !== data.confirmPassword
      ) {
        ctx.addIssue({
          code: 'custom',
          message: 'As senhas não conferem!',
          path: ['confirmPassword'],
        });
      }
    }
  });

// Troca de senha pelo próprio usuário logado (Meu perfil).
export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'Informe a senha atual.'),
    newPassword: passwordSchema,
  })
  .refine((d) => d.newPassword !== d.currentPassword, {
    message: 'A nova senha deve ser diferente da atual.',
    path: ['newPassword'],
  });

export type ChangePasswordSchema = z.infer<typeof changePasswordSchema>;

// Recuperação de senha por código enviado ao e-mail (público, sem sessão).
export const forgotPasswordSchema = z.object({
  email: z.email('E-mail inválido!'),
});

export const resetPasswordSchema = z.object({
  email: z.email('E-mail inválido!'),
  otp: z.string().regex(/^\d{6}$/, 'O código tem 6 dígitos!'),
  newPassword: passwordSchema,
});

export { passwordSchema };

export type ForgotPasswordSchema = z.infer<typeof forgotPasswordSchema>;
export type ResetPasswordSchema = z.infer<typeof resetPasswordSchema>;
export type SignInSchema = z.infer<typeof signInSchema>;
export type UpdateProfileSchema = z.infer<typeof updateProfileSchema>;
